import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { Range, getTrackBackground } from 'react-range';
import styles from './RangeSlider.module.scss';
import ReadyOnlyInput from '../Form/ReadOnlyInput/ReadyOnlyInput';
import cn from 'classnames';
import useQuery from '../../hooks/useQuery';
const RangeSlider = forwardRef(({ min, max, onChange, title, show }, ref) => {
    const STEP = 1;
    const query = useQuery();
    const maxDefaultKey = `${title.toLowerCase()}Max`;
    const maxDefault = query[maxDefaultKey] || max.toString();
    const minDefaultKey = `${title.toLowerCase()}Min`;
    const minDefault = query[minDefaultKey] || min.toString();
    const [values, setValues] = useState([parseInt(minDefault, 10), parseInt(maxDefault, 10)]);
    const [showClearIcon, setShowClearIcon] = useState(false);
    useEffect(() => {
        setValues([parseInt(minDefault, 10), parseInt(maxDefault, 10)]);
    }, [query]);
    useEffect(() => {
        if (values[0] !== min || values[1] !== max) {
            setShowClearIcon(true);
        }
        else {
            setShowClearIcon(false);
        }
    }, [values]);
    const handleFinalChange = useCallback((values) => {
        setValues(values);
        onChange({
            [title.toLowerCase() + 'Min']: values[0],
            [title.toLowerCase() + 'Max']: values[1]
        });
    }, [title, setValues, onChange]);
    const handleChange = useCallback((values) => {
        setValues(values);
    }, [setValues]);
    useImperativeHandle(ref, () => ({
        handleParentReset: () => {
            handleReset();
        }
    }));
    const handleReset = () => {
        setValues([min, max]);
        onChange({
            [title.toLowerCase() + 'Min']: '',
            [title.toLowerCase() + 'Max']: ''
        });
    };
    return (_jsxs("div", Object.assign({ className: styles.element, style: { display: show ? 'block' : 'none' } }, { children: [_jsx(Range, { values: values, step: STEP, min: min, max: max, onFinalChange: handleFinalChange, onChange: handleChange, renderTrack: ({ props, children }) => (_jsx("div", Object.assign({ onMouseDown: props.onMouseDown, onTouchStart: props.onTouchStart, style: Object.assign(Object.assign({}, props.style), { height: '36px', display: 'flex', width: '100%' }) }, { children: _jsx("div", Object.assign({ ref: props.ref, style: {
                            height: '4px',
                            width: '100%',
                            borderRadius: '100px',
                            background: getTrackBackground({
                                values,
                                colors: ['#E9E7E4', '#285491', '#E9E7E4'],
                                min: min,
                                max: max
                            }),
                            alignSelf: 'center'
                        } }, { children: children })) }))), renderThumb: ({ props }) => (_jsx("div", Object.assign({}, props, { style: Object.assign({}, props.style) }, { children: _jsx("div", { style: {
                            height: '16px',
                            width: '5px',
                            backgroundColor: '#285491',
                            borderRadius: '10rem'
                        } }) }))) }), _jsxs("div", Object.assign({ className: cn(styles.inputs, 'd-flex ') }, { children: [_jsx(ReadyOnlyInput, { className: 'flex-1', value: values[0] }), _jsx(ReadyOnlyInput, { className: 'flex-1', value: values[1] })] }))] })));
});
export default RangeSlider;
